import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { map } from 'rxjs'

import { ParticipantService } from '@participant/services/participant.service'

export const authGuard: CanActivateFn = () => {
  const participantService = inject(ParticipantService)
  const router = inject(Router)

  return participantService.loadParticipant().pipe(
    map(SConfig => SConfig.participation),
    map(participant => {
      if (!participant.authenticated) {
        router.navigate(['/auth', 'login'])
      }

      return true
    })
  )
}
